import { useNavigate } from "react-router-dom";
import TopBar from "@/components/TopBar";
import { useOutfitDraft } from "@/context/OutfitDraftContext";

const STYLES = [
  // User-requested 2026 trend-aware lineup (Instagram/TikTok/Pinterest aesthetics)
  { id: "modern streetwear",   name: "Modern Streetwear",   blurb: "Oversized, layered, 2026" },
  { id: "old money",           name: "Old Money",           blurb: "Quiet luxury, heritage" },
  { id: "earthy",              name: "Earthy",              blurb: "Linen, sun-baked, grounded" },
  { id: "y2k",                 name: "Y2K",                 blurb: "Early 2000s revival, bold" },
  { id: "luxury casual",       name: "Luxury Casual",       blurb: "Elevated everyday, refined" },
  { id: "women streetwear",    name: "Women Streetwear",    blurb: "Crop, cargo, sneaker culture" },
  { id: "gym style",           name: "Gym Style",           blurb: "Athleisure, performance fit" },
  { id: "business casual",     name: "Business Casual",     blurb: "Tailored without a tie" },
  // Classics retained
  { id: "casual",              name: "Casual",              blurb: "Easy, everyday, relaxed" },
  { id: "smart casual",        name: "Smart Casual",        blurb: "Crisp, intentional" },
  { id: "minimalist",          name: "Minimalist",          blurb: "Neutral, clean, calm" },
  { id: "techwear",            name: "Techwear",            blurb: "Functional, modular, dark" },
  { id: "vintage",             name: "Vintage",             blurb: "Retro cuts, lived-in" },
  { id: "formal",              name: "Formal",              blurb: "Tailored, sharp, evening" },
];

export default function StyleScreen() {
  const navigate = useNavigate();
  const { draft, update } = useOutfitDraft();

  const pick = (s) => {
    update({ style: s.id });
    setTimeout(() => navigate("/results"), 120);
  };

  return (
    <div className="screen fade-in" data-testid="style-screen">
      <TopBar title="STEP 3 OF 3" />
      <div style={{ marginBottom: 22 }}>
        <div className="eyebrow" style={{ marginBottom: 10 }}>STYLE</div>
        <h2 className="h1" style={{ fontSize: 34 }}>
          Pick a <em className="serif" style={{ fontStyle: "italic", fontWeight: 300 }}>vibe</em>
        </h2>
        <p className="body" style={{ marginTop: 12 }}>
          We&apos;ll build the outfit around this aesthetic.
        </p>
      </div>

      <div className="stagger" style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}>
        {STYLES.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`card ${draft.style === s.id ? "selected" : ""}`}
            onClick={() => pick(s)}
            data-testid={`style-option-${s.id.replace(/\s+/g, "-")}`}
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "left" }}
          >
            <div>
              <div className="h3" style={{ color: "#fff" }}>{s.name}</div>
              <div className="tiny" style={{ marginTop: 2, color: "rgba(255,255,255,0.5)" }}>{s.blurb}</div>
            </div>
            <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 20 }}>›</div>
          </button>
        ))}
      </div>
    </div>
  );
}
